function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M100.988 50.0315C100.992 58.5269 98.83 66.8831 94.7058 74.3103C90.5816 81.7374 84.6315 87.9902 77.418 92.4776C76.0146 93.3547 74.567 94.1589 73.0808 94.8871C71.6268 95.6081 70.1357 96.2515 68.6136 96.8147C68.5559 96.8429 68.4963 96.8671 68.4353 96.887L68.0594 97.0267L67.9293 97.0701C66.686 97.5231 65.4186 97.9215 64.1271 98.2652C63.0717 98.5592 61.9971 98.8098 60.9128 99.0266C58.1629 99.5836 55.3707 99.906 52.5662 99.9904C52.2867 99.9904 52.012 99.9904 51.7325 99.9904C51.453 99.9904 51.294 99.9904 51.0723 99.9904H50.4025H49.535C47.0129 99.9182 44.4999 99.6556 42.0174 99.2049C41.0921 99.0411 40.1717 98.8435 39.2657 98.6218C38.885 98.5351 38.5091 98.4435 38.138 98.3375C38.0869 98.3282 38.0368 98.3137 37.9886 98.2941C37.5983 98.1978 37.2176 98.0869 36.8321 97.9713C36.4465 97.8556 35.9839 97.7207 35.5647 97.5809C35.2434 97.4749 34.9109 97.3641 34.5671 97.2484C33.2226 96.7665 31.9022 96.2557 30.6155 95.6822L29.8348 95.3208C29.7288 95.2774 29.6228 95.2244 29.5216 95.1762C21.4419 91.3334 14.5411 85.3933 9.53893 77.9753C4.53672 70.5573 1.61627 61.9332 1.08213 53.0021C0.547987 44.0711 2.41971 35.1603 6.50212 27.199C10.5845 19.2377 16.7281 12.5174 24.2922 7.73899C31.8563 2.96057 40.5638 0.299016 49.5068 0.0318625C58.4498 -0.235291 67.3007 1.90175 75.1366 6.22013C82.9724 10.5385 89.5062 16.8801 94.0565 24.5835C98.6069 32.2869 101.007 41.0701 101.007 50.0171L100.988 50.0315Z",
  fill: "#15A9E1"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3018_12611)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M71.3156 75.945C71.3156 78.2676 69.7672 80.0096 67.3478 80.0096H34.6382C32.2188 80.0096 30.6704 78.2676 30.6704 75.945V26.3967C30.6704 24.0741 32.2188 21.945 34.6382 21.945H67.2511C69.7672 21.945 71.3156 24.0741 71.3156 26.3967V75.945Z",
  fill: "#50BB75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.6704 26.3967C30.6704 24.0741 32.2188 21.945 34.6382 21.945H67.2511C69.7672 21.945 71.3156 24.0741 71.3156 26.3967V75.945C71.3156 78.2676 69.5736 80.0096 67.0575 80.0096",
  fill: "#0AA06E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.7026 24.3644C59.7026 24.7515 59.1219 24.8483 58.7348 24.8483H43.2509C42.8638 24.8483 42.2832 24.7515 42.2832 24.3644V20.5902C42.2832 20.2999 42.8638 20.0096 43.2509 20.0096H58.7348C59.1219 20.0096 59.7026 20.2999 59.7026 20.5902V24.3644Z",
  fill: "#40406B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.5091 28.7192H36.4768V74.2031H65.5091V28.7192Z",
  fill: "#EAEAEA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.4768 28.7192H65.5091V74.2031",
  fill: "#DDDDDD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.1219 32.5902H40.3477V39.3644H47.1219V32.5902Z",
  fill: "#A8A8A8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.6059 42.2676H39.3801V44.2031H62.6059V42.2676Z",
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.6059 48.0741H39.3801V50.0096H62.6059V48.0741Z",
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.6059 53.8805H39.3801V55.816H62.6059V53.8805Z",
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.6059 59.687H39.3801V61.6225H62.6059V59.687Z",
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.0253 65.4934H39.3801V67.4289H50.0253V65.4934Z",
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.6059 65.4934H59.7027V63.5579H56.7995V65.4934H53.8962V68.3967H56.7995V71.2999H59.7027V68.3967H62.6059V65.4934Z",
  fill: "#F15249"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.6058 33.5579H50.9929V37.4289H62.6058V33.5579Z",
  fill: "#E88610"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3018_12611"
}, /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 60,
  fill: "white",
  transform: "translate(20.9929 20.0096)"
})));

var SvgMedicalRecord = function SvgMedicalRecord(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 100,
    viewBox: "0 0 102 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedicalRecord, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medical-record.2db04aba.svg";
export { ForwardRef as ReactComponent };